import React from "react";
import { withRouter } from "react-router";

import "../css/ProgressBar.scss";

class ProgressBar extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			stepsCompleted: [],
			showProgressBar: false
		};

		this.props.history.listen((location, action) => {
			const currentLocation = location.pathname.replace("/", "").toLowerCase();

			// If there's a redirect to the home screen, currentLocation will be empty.
			// This redirect shouldn't count against the stepsCompleted list
			if (currentLocation === "") {
				return;
			}

			if (action === "POP") {
				this.setState({
					stepsCompleted: this.state.stepsCompleted.slice(0, -1)
				});
			}

			if (action === "PUSH" || action === "REPLACE") {
				this.setState({
					stepsCompleted: [...this.state.stepsCompleted, currentLocation]
				});
			}

			if (!this.state.showProgressBar && currentLocation === "industry") {
				this.setState({
					showProgressBar: true
				});
			}

			if (this.state.showProgressBar && currentLocation === "generating") {
				this.setState({
					showProgressBar: false
				});
			}
		});
	}

	calculateProgessBarWidth = () => {
		const stepsCompleted = this.state.stepsCompleted.length;
		const stepsCount = this.props.routesConfig.length;

		return (stepsCompleted / stepsCount) * 100 + "%";
	};

	renderList() {
		// routesConfig is passed from <AppRouter />
		return this.props.routesConfig.map(({ name }) => {
			const isActiveStep =
				this.state.stepsCompleted.indexOf(name) > -1 ? "active" : "";
			return (
				<div key={name} className={`progress-step ${isActiveStep} ${name}`}>
					{name}
				</div>
			);
		});
	}

	render() {
		return (
			<div
				className={
					"progress-bar-container " +
					(this.state.showProgressBar ? "active" : "")
				}>
				<div className="progress-bar">
					<div
						className="progress-bar-background"
						style={{ width: this.calculateProgessBarWidth() }}
					/>
					<div className="progress-bar-steps">{this.renderList()}</div>
				</div>
			</div>
		);
	}
}

export default withRouter(ProgressBar);
